export default "__VITE_ASSET__DA0mCk0R__"